document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-sc-product]').forEach((section) => {
    const slides = [...section.querySelectorAll('[data-sc-slide]')];
    const thumbs = [...section.querySelectorAll('[data-sc-thumb]')];
    let activeSlide = 0;

    const showSlide = (next) => {
      if (!slides.length) return;
      activeSlide = (next + slides.length) % slides.length;
      slides.forEach((slide, index) => slide.classList.toggle('is-active', index === activeSlide));
      thumbs.forEach((thumb, index) => classToggle(thumb, 'is-active', index === activeSlide));
      thumbs[activeSlide]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    const classToggle = (element, name, force) => element?.classList.toggle(name, force);
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.scThumb))));
    section.querySelector('[data-sc-gallery-prev]')?.addEventListener('click', () => showSlide(activeSlide - 1));
    section.querySelector('[data-sc-gallery-next]')?.addEventListener('click', () => showSlide(activeSlide + 1));

    const galleryStage = section.querySelector('.sc-gallery__stage');
    let touchStartX = 0;
    let touchStartY = 0;
    let lastGallerySwipe = 0;
    galleryStage?.addEventListener('touchstart', (event) => {
      if (event.touches.length !== 1) return;
      touchStartX = event.changedTouches[0]?.clientX || 0;
      touchStartY = event.changedTouches[0]?.clientY || 0;
    }, { passive: true });
    galleryStage?.addEventListener('touchend', (event) => {
      const distanceX = (event.changedTouches[0]?.clientX || 0) - touchStartX;
      const distanceY = (event.changedTouches[0]?.clientY || 0) - touchStartY;
      if (Math.abs(distanceX) < 44 || Math.abs(distanceX) <= Math.abs(distanceY) * 1.15) return;
      lastGallerySwipe = performance.now();
      showSlide(activeSlide + (distanceX < 0 ? 1 : -1));
    }, { passive: true });
    galleryStage?.addEventListener('click', (event) => {
      if (performance.now() - lastGallerySwipe > 500) return;
      event.preventDefault();
      event.stopPropagation();
      lastGallerySwipe = 0;
    }, true);

    const variantSelect = section.querySelector('[data-sc-variant-select]');
    const optionInputs = [...section.querySelectorAll('[data-sc-option] input')];
    const price = section.querySelector('[data-sc-price]');
    const compare = section.querySelector('[data-sc-compare]');
      const stock = section.querySelector('[data-sc-stock]');
      const addButton = section.querySelector('[data-sc-add]');

      const syncSamplesLinks = (chosen = []) => {
        const baseProduct = section.dataset.productHandle || '';
        const colourGroup = [...section.querySelectorAll('[data-sc-option]')].find((group) => /kleur|color/i.test(group.querySelector('legend')?.textContent || ''));
        const colour = colourGroup?.querySelector('input:checked')?.value || '';
        section.querySelectorAll('[data-sc-samples-link]').forEach((link) => {
          const url = new URL(link.getAttribute('href'), window.location.origin);
          if (baseProduct) url.searchParams.set('product', baseProduct);
          if (colour) url.searchParams.set('kleur', colour);
          link.href = `${url.pathname}${url.search}${url.hash}`;
        });
      };

    const syncVariant = () => {
      if (!variantSelect) return;
      const chosen = [...section.querySelectorAll('[data-sc-option]')].map((group) => {
        const checked = group.querySelector('input:checked');
        group.querySelector('[data-sc-option-label]').textContent = checked?.value || '';
        return checked?.value;
      });
      const match = [...variantSelect.options].find((option) => {
        try { return JSON.stringify(JSON.parse(option.dataset.options)) === JSON.stringify(chosen); }
        catch (_) { return false; }
      });
      if (!match) return;
      syncSamplesLinks(chosen);
      variantSelect.value = match.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      section.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variantId: match.value } }));
      if (price) price.textContent = match.dataset.price;
      const mobilePrice = section.querySelector('[data-sc-mobile-price]');
      if (mobilePrice) mobilePrice.textContent = match.dataset.price;
      const mobileSummaryPrice = section.querySelector('[data-sc-mobile-summary-price]');
      if (mobileSummaryPrice) mobileSummaryPrice.textContent = match.dataset.price;
      if (compare) {
        compare.textContent = match.dataset.compare || '';
        compare.hidden = !match.dataset.compare;
      }
      const available = match.dataset.available === 'true';
      if (addButton) {
        addButton.disabled = !available;
        addButton.querySelector('span').textContent = available ? 'Aan winkelwagen toevoegen' : 'Uitverkocht';
      }
      const mobileAdd = section.querySelector('[data-sc-mobile-add]');
      if (mobileAdd) {
        mobileAdd.disabled = !available;
        mobileAdd.textContent = available ? 'In winkelwagen' : 'Uitverkocht';
      }
      classToggle(stock, 'is-unavailable', !available);
      const stockText = stock?.querySelector('span');
      if (stockText) stockText.textContent = available ? 'Direct uit voorraad leverbaar' : 'Tijdelijk niet op voorraad';
      if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${match.value}`);
    };
    optionInputs.forEach((input) => input.addEventListener('change', syncVariant));
    syncSamplesLinks();

    const wishlistButton = section.querySelector('[data-sc-wishlist]');
    if (wishlistButton) {
      const productKey = `studio-cosy-moodboard-${wishlistButton.dataset.productId}`;
      let saved = false;
      try { saved = localStorage.getItem(productKey) === 'true'; } catch (_) {}
      const renderWishlist = () => {
        wishlistButton.classList.toggle('is-saved', saved);
        wishlistButton.setAttribute('aria-pressed', String(saved));
        wishlistButton.setAttribute('aria-label', saved ? 'Verwijder van moodboard' : 'Bewaar op moodboard');
        const label = wishlistButton.querySelector('.visually-hidden');
        if (label) label.textContent = saved ? 'Verwijder van moodboard' : 'Bewaar op moodboard';
      };
      renderWishlist();
      wishlistButton.addEventListener('click', () => {
        saved = !saved;
        try { localStorage.setItem(productKey, String(saved)); } catch (_) {}
        renderWishlist();
      });
    }

    const dateInput = section.querySelector('[data-sc-delivery-date]');
    if (dateInput) {
      const minimum = new Date();
      minimum.setDate(minimum.getDate() + 3);
      dateInput.min = minimum.toISOString().slice(0, 10);
      const output = section.querySelector('[data-sc-delivery-output]');
      const renderDate = () => {
        if (!output) return;
        if (!dateInput.value) {
          output.textContent = 'Selecteer een beschikbare datum';
          return;
        }
        const selected = new Date(`${dateInput.value}T12:00:00`);
        output.textContent = selected.toLocaleDateString('nl-NL', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
      };
      dateInput.addEventListener('input', renderDate);
      dateInput.addEventListener('change', () => {
        const validation = window.StudioCosyDeliveryRules?.validate(dateInput, { clearInvalid: true });
        if (validation && !validation.valid) {
          renderDate();
          return;
        }
        renderDate();
        form?.dispatchEvent(new CustomEvent('delivery-date:change', { bubbles: true, detail: { value: dateInput.value } }));
      });
      renderDate();
    }

    const form = section.querySelector('[data-sc-product-form]');
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!addButton || addButton.disabled) return;
      addButton.disabled = true;
      addButton.classList.add('is-loading');
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error('Toevoegen mislukt');
        if (dateInput?.value && window.StudioCosyDeliveryDate) await window.StudioCosyDeliveryDate.sync(dateInput.value, { force: true });
        const [pageResponse, cartResponse] = await Promise.all([fetch(location.href), fetch('/cart.js')]);
        const pageHtml = await pageResponse.text();
        const cart = await cartResponse.json();
        document.dispatchEvent(new CustomEvent('studio-cosy:add-to-cart', { detail: {
          source_component: 'product_page',
          product_id: section.dataset.productId || '',
          product_handle: section.dataset.productHandle || '',
          product_title: section.querySelector('h1')?.textContent?.trim() || '',
          variant_id: form.querySelector('[name="id"]')?.value || '',
          quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
          cart_item_count: cart.item_count
        } }));
        const parsed = new DOMParser().parseFromString(pageHtml, 'text/html');
        const freshDrawer = parsed.querySelector('[data-cart-drawer]');
        const currentDrawer = document.querySelector('[data-cart-drawer]');
        if (freshDrawer && currentDrawer) currentDrawer.replaceWith(freshDrawer);
        const count = document.querySelector('[data-cart-count]');
        if (count) { count.textContent = cart.item_count; count.hidden = false; }
        const drawer = document.querySelector('[data-cart-drawer]');
        const overlay = document.querySelector('[data-cart-overlay]');
        drawer?.classList.add('open');
        drawer?.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.hidden = false;
        document.body.classList.add('drawer-open');
        const close = () => { drawer?.classList.remove('open'); drawer?.setAttribute('aria-hidden', 'true'); if (overlay) overlay.hidden = true; document.body.classList.remove('drawer-open'); };
        drawer?.querySelector('[data-cart-close]')?.addEventListener('click', close);
        overlay?.addEventListener('click', close, { once: true });
      } catch (_) {
        form.submit();
      } finally {
        addButton.disabled = false;
        addButton.classList.remove('is-loading');
      }
    }, true);

    const mobileBuy = section.querySelector('[data-sc-mobile-buy]');
    const mobileAdd = section.querySelector('[data-sc-mobile-add]');
    mobileAdd?.addEventListener('click', () => addButton?.click());
    if (mobileBuy && addButton) {
      mobileBuy.hidden = false;
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => {
          mobileBuy.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.15 });
        observer.observe(addButton);
      }
    }

    const lightbox = section.querySelector('[data-sc-lightbox]');
    const lightboxImage = lightbox?.querySelector('img');
    const lightboxViewport = lightbox?.querySelector('[data-sc-lightbox-viewport]');
    const lightboxPrevious = lightbox?.querySelector('[data-sc-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-sc-lightbox-next]');
    const lightboxClose = lightbox?.querySelector('[data-sc-lightbox-close]');
    let lightboxImages = [];
    let lightboxIndex = 0;
    let lightboxOpener = null;
    let lockedScrollY = 0;
    let changeTimer = 0;
    const originalBodyStyles = {};
    try { lightboxImages = JSON.parse(lightbox?.querySelector('[data-sc-lightbox-images]')?.textContent || '[]'); } catch (_) {}
    const showLightbox = (index) => {
      if (!lightbox || !lightboxImage || !lightboxImages.length) return;
      lightboxIndex = (index + lightboxImages.length) % lightboxImages.length;
      lightbox.classList.add('is-changing', 'is-used');
      lightboxImage.src = lightboxImages[lightboxIndex].src;
      lightboxImage.alt = lightboxImages[lightboxIndex].alt || '';
      const count = lightbox.querySelector('[data-sc-lightbox-count]');
      if (count) count.textContent = `${lightboxIndex + 1} / ${lightboxImages.length}`;
      window.clearTimeout(changeTimer);
      changeTimer = window.setTimeout(() => lightbox.classList.remove('is-changing'), 140);
    };
    const navigateLightbox = (direction) => {
      if (lightboxImages.length < 2) return;
      showLightbox(lightboxIndex + direction);
    };
    const lockPageForLightbox = () => {
      lockedScrollY = window.scrollY;
      ['position', 'top', 'left', 'right', 'width', 'overflow'].forEach((property) => { originalBodyStyles[property] = document.body.style[property]; });
      document.body.style.position = 'fixed';
      document.body.style.top = `-${lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('sc-lightbox-open');
      document.body.classList.add('sc-lightbox-open');
    };
    const unlockPageForLightbox = () => {
      Object.entries(originalBodyStyles).forEach(([property, value]) => { document.body.style[property] = value; });
      document.documentElement.classList.remove('sc-lightbox-open');
      document.body.classList.remove('sc-lightbox-open');
      window.scrollTo(0, lockedScrollY);
    };
    const openLightbox = (index, opener) => {
      if (!lightbox || !lightboxImages.length) return;
      lightboxOpener = opener || document.activeElement;
      lightbox.classList.remove('is-used');
      showLightbox(index);
      lightbox.classList.remove('is-used');
      const hasMultipleImages = lightboxImages.length > 1;
      if (lightboxPrevious) lightboxPrevious.hidden = !hasMultipleImages;
      if (lightboxNext) lightboxNext.hidden = !hasMultipleImages;
      const hint = lightbox.querySelector('.sc-lightbox__hint');
      if (hint) hint.hidden = !hasMultipleImages;
      lightbox.hidden = false;
      lockPageForLightbox();
      window.requestAnimationFrame(() => lightboxClose?.focus({ preventScroll: true }));
    };
    const closeLightbox = () => {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      unlockPageForLightbox();
      lightboxOpener?.focus?.({ preventScroll: true });
    };
    section.querySelectorAll('[data-sc-lightbox-open]').forEach((button) => button.addEventListener('click', () => openLightbox(Number(button.dataset.scLightboxOpen), button)));
    lightboxClose?.addEventListener('click', closeLightbox);
    lightboxPrevious?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); navigateLightbox(-1); });
    lightboxNext?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); navigateLightbox(1); });
    lightbox?.addEventListener('click', (event) => { if (event.target === lightbox) closeLightbox(); });

    if (lightbox && lightboxViewport) {
      let gesture = null;
      const beginSwipe = (x, y, pointerId = null) => {
        gesture = { x, y, pointerId, time: performance.now() };
        lightboxViewport.classList.add('is-dragging');
      };
      const finishSwipe = (x, y) => {
        if (!gesture) return;
        const distanceX = x - gesture.x;
        const distanceY = y - gesture.y;
        const elapsed = Math.max(1, performance.now() - gesture.time);
        const threshold = Math.min(90, Math.max(44, lightboxViewport.clientWidth * .12));
        const isHorizontal = Math.abs(distanceX) > Math.abs(distanceY) * 1.15;
        const hasDistance = Math.abs(distanceX) >= threshold;
        const hasVelocity = Math.abs(distanceX) / elapsed > .55 && Math.abs(distanceX) > 32;
        lightboxViewport.classList.remove('is-dragging');
        gesture = null;
        if (isHorizontal && (hasDistance || hasVelocity)) navigateLightbox(distanceX < 0 ? 1 : -1);
      };

      if ('PointerEvent' in window) {
        lightboxViewport.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
          beginSwipe(event.clientX, event.clientY, event.pointerId);
          lightboxViewport.setPointerCapture?.(event.pointerId);
        });
        lightboxViewport.addEventListener('pointerup', (event) => {
          if (!gesture || gesture.pointerId !== event.pointerId) return;
          finishSwipe(event.clientX, event.clientY);
          lightboxViewport.releasePointerCapture?.(event.pointerId);
        });
        lightboxViewport.addEventListener('pointercancel', () => {
          gesture = null;
          lightboxViewport.classList.remove('is-dragging');
        });
      } else {
        lightboxViewport.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          beginSwipe(event.touches[0].clientX, event.touches[0].clientY);
        }, { passive: true });
        lightboxViewport.addEventListener('touchend', (event) => {
          if (!gesture || !event.changedTouches.length) return;
          finishSwipe(event.changedTouches[0].clientX, event.changedTouches[0].clientY);
        }, { passive: true });
      }

      const preventPinchZoom = (event) => {
        if ((event.touches && event.touches.length > 1) || event.type.startsWith('gesture')) event.preventDefault();
      };
      lightbox.addEventListener('touchmove', preventPinchZoom, { passive: false });
      lightbox.addEventListener('gesturestart', preventPinchZoom, { passive: false });
      lightbox.addEventListener('gesturechange', preventPinchZoom, { passive: false });
    }

    const currentProductData = section.querySelector('[data-sc-current-product]');
    const recentSection = section.querySelector('[data-sc-recent]');
    const recentGrid = section.querySelector('[data-sc-recent-grid]');
    if (currentProductData && recentSection && recentGrid) {
      try {
        const currentProduct = JSON.parse(currentProductData.textContent);
        const history = JSON.parse(localStorage.getItem('studio-cosy-recent-products') || '[]');
        const previous = history.filter((item) => String(item.id) !== String(currentProduct.id)).slice(0, 4);
        previous.forEach((item) => {
          const card = document.createElement('a');
          card.className = 'product-card';
          card.href = item.url;
          const media = document.createElement('div');
          media.className = 'product-card-media';
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.title;
          image.loading = 'lazy';
          media.appendChild(image);
          if (item.dimensions) { const badge = document.createElement('span'); badge.className = 'product-card-dimensions'; badge.textContent = item.dimensions; media.appendChild(badge); }
          const info = document.createElement('div');
          info.className = 'product-card-info';
          const title = document.createElement('h3'); title.textContent = item.title;
          const priceElement = document.createElement('span'); priceElement.textContent = item.price;
          info.append(title, priceElement); card.append(media, info); recentGrid.appendChild(card);
        });
        if (previous.length) recentSection.hidden = false;
        localStorage.setItem('studio-cosy-recent-products', JSON.stringify([currentProduct, ...previous].slice(0, 6)));
      } catch (_) {}
    }

    document.addEventListener('keydown', (event) => {
      if (!lightbox || lightbox.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        navigateLightbox(-1);
        return;
      }
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        navigateLightbox(1);
        return;
      }
      if (event.key === 'Tab') {
        const controls = [lightboxClose, lightboxPrevious, lightboxNext].filter((control) => control && !control.hidden);
        if (!controls.length) return;
        const firstControl = controls[0];
        const lastControl = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === firstControl) {
          event.preventDefault();
          lastControl.focus();
        } else if (!event.shiftKey && document.activeElement === lastControl) {
          event.preventDefault();
          firstControl.focus();
        }
      }
    });
  });
});
